import { User } from '@/domain/types/user';

export type MemberSearchField =
  | 'document'
  | 'name'
  | 'lastname'
  | 'email'
  | 'area'
  | 'department'
  | 'position'
  | 'unit';

const fullName = (user: User) => `${user.name ?? ''} ${user.lastname ?? ''}`;

/** Copia de la lista ordenada por nombre completo, sin distinguir tildes ni mayúsculas. */
export function sortByFullName(users: User[]): User[] {
  return [...users].sort((a, b) =>
    fullName(a).localeCompare(fullName(b), 'es', { sensitivity: 'base' }),
  );
}

/**
 * Filtra por prefijo del campo elegido, sin distinguir mayúsculas. Es el
 * equivalente en memoria de la búsqueda del servidor, para filtrar entre los
 * miembros ya cargados. El documento puede estar guardado como número.
 */
export function filterUsers(
  users: User[],
  field: MemberSearchField,
  term: string,
): User[] {
  const needle = term.trim().toLowerCase();
  if (!needle) return users;
  return users.filter((user) =>
    String(user[field] ?? '')
      .toLowerCase()
      .startsWith(needle),
  );
}
